import {LIST_DISPLAY_STRATEGY} from '@wix/wix-events-commons-statics'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {ALL_CATEGORIES_FILTER} from '../../../../commons/constants/settings'
import {getInitialCategoryId} from '../../../../commons/selectors/categories'
import settingsParams from '../../settingsParams'
import {createAsyncAction} from '../services/redux-toolkit'
import {reloadAllCategories} from './categories'
import {loadFeaturedEvent, reloadEvents} from './events'
import {settingsTabChanged} from './settings-panel'
import {updateSiteSettings} from './site-settings'
import {setVeloCategoryFilter} from './velo-overrides'

export const SettingsUpdatedActionType = {
  SETTINGS: 'SETTINGS',
  SITE_SETTINGS: 'SITE_SETTINGS',
  SELECT_EVENT: 'SELECT_EVENT',
  DISPLAY_EVENT: 'DISPLAY_EVENT',
  HIDE_EVENT: 'HIDE_EVENT',
  HIDE_EVENT_PENDING: 'HIDE_EVENT/pending',
  NAVIGATE_TO_PAGE: 'NAVIGATE_TO_PAGE',
  NAVIGATE_TO_PAGE_PENDING: 'NAVIGATE_TO_PAGE/pending',
  SETTINGS_TAB_CHANGED_PENDING: 'SETTINGS_TAB_CHANGED/pending',
  SETTINGS_TAB_CHANGED: 'SETTINGS_TAB_CHANGED',
  RELOAD_EVENTS: 'RELOAD_EVENTS',
  RELOAD_FEATURED_EVENT: 'RELOAD_FEATURED_EVENT',
}

export interface SettingsUpdateAction {
  type: string
  [key: string]: any
}

const reloadCategories = async (dispatch: Function, flowAPI: ControllerFlowAPI) => {
  const listDisplayStrategy = flowAPI.settings.get(settingsParams.listDisplayStrategy) as LIST_DISPLAY_STRATEGY

  if (listDisplayStrategy === LIST_DISPLAY_STRATEGY.MULTIPLE_CATEGORIES) {
    const {categories} = await dispatch(reloadAllCategories()).unwrap()
    const showCategoryMenu = flowAPI.settings.get(settingsParams.showCategoryMenu) as boolean

    if (showCategoryMenu) {
      const initialCategoryId = getInitialCategoryId(flowAPI.settings.get, categories)

      if (initialCategoryId === ALL_CATEGORIES_FILTER) {
        dispatch(setVeloCategoryFilter(null))
      } else {
        dispatch(setVeloCategoryFilter(initialCategoryId))
      }
    } else {
      dispatch(setVeloCategoryFilter(null))
    }
  }
}

export const updateSettings = createAsyncAction<void, SettingsUpdateAction>(
  'UPDATE_SETTINGS',
  async (action, {dispatch, extra: {flowAPI}}) => {
    switch (action.type) {
      case SettingsUpdatedActionType.SITE_SETTINGS:
        dispatch(updateSiteSettings(action.settings))
        break
      case SettingsUpdatedActionType.SETTINGS_TAB_CHANGED:
      case SettingsUpdatedActionType.SETTINGS_TAB_CHANGED_PENDING:
        const navigationInfo = action.payload
        dispatch(settingsTabChanged(navigationInfo))
        break
      case SettingsUpdatedActionType.RELOAD_EVENTS:
        await reloadCategories(dispatch, flowAPI)
        dispatch(reloadEvents())
        break
      case SettingsUpdatedActionType.RELOAD_FEATURED_EVENT:
        dispatch(loadFeaturedEvent())
        break
      default:
        break
    }
  },
)
